import { Component, OnInit, Input } from '@angular/core';
import { CustomerDetailsViewModel } from '../../../../../business-entities/customer-view.model';
import { Filter } from '../../../../../business-entities/Filter';
import { PagerData } from '../../../../../business-entities/PagerData';
import { Constant } from '../../../../../../../../Autofacets-Core/src/app/utils/constant';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ClipboardService } from 'ngx-clipboard';
import { PaginationService } from '../../../../../services/pagination.service';
import { CustomerService } from '../../../../../business-services/customer.service';

@Component({
  selector: 'app-multi-customer-list',
  templateUrl: './multi-customer-list.component.html'
})
export class MultiCustomerListComponent implements OnInit {
  @Input() customerList: CustomerDetailsViewModel[];
  @Input() totalCount: number;
  customer: any;
  searchTerm: string;
  isWidgetData: string;
  filter: Filter = new Filter();
  filterItems: any[];
  isSelectActive = false;
  pagerData: PagerData = {
    page: 1,
    pagerSize: Constant.GridPagerSize,
  };
  activePanel = ['first', 'second'];
  pager: any = {};
  pagedItems: any[];
  dataRows: any[] = [];
  constructor(    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private clipboardApi: ClipboardService,
    private pagerService: PaginationService,
    private service: CustomerService) { }

  ngOnInit(): void {
    // This is intentional
  }
  resetPagerData(pageData: any) {
    this.pager = pageData.pager;
    this.pagedItems = pageData.pagedItems;
    pageData.recordSize = this.totalCount;
  }

  supplierInitiliseGridFromServer(data: any[], count: number) {
    if (data != null && data !== undefined) {
      this.dataRows = data;
      return this.refreshGridFromServer(data, count);
    }
    return this.refreshGridFromServer([], 0);
  }

  refreshGridFromServer(data: any[], count: number) {
    this.filterItems = data;
    this.filter.page = data.length === 0 ? 0 : 1;
    return this.initilisePagerFromServer(
      this.filter.page,
      Number(this.filter.pageSize),
      count
    );
  }

  initilisePagerFromServer(
    page: number,
    _pageSize: number,
    count: number = this.filterItems.length
  ) {
    let length =
      this.filterItems.length <= Constant.GridPagerSize
        ? Constant.GridPagerSize
        : this.pagerData.pagerSize;
    this.filter.pageSize = length;
    this.pager = this.pagerService.getPager(count, page, length);
    this.pagedItems = this.filterItems;
    return { pager: this.pager, pagedItems: this.pagedItems };
  }
  async setPage(pagerData: PagerData) {
    if (
      pagerData == null ||
      pagerData === undefined ||
      pagerData.page < 1 ||
      pagerData.page > this.pager.totalPages
    ) {
      return;
    }
    this.pagerData.page = pagerData.page;
    this.pagerData.pagerSize = pagerData.pagerSize;
    this.service.customerListRequest.startRecordNumber =
      pagerData.pagerSize * (pagerData.page - 1);
    this.service.customerListRequest.pageSize = pagerData.pagerSize;
  }
  onCustomerSelect(customerIndex: number) {
    this.customerList.forEach((item, index) => {
      if (index == customerIndex) {
        item.isSelected = true;
        this.isSelectActive = true;
      } else {
        item.isSelected = false;
      }
    });
  }

  onSelect() {
    let cust = this.customerList.filter((customer) => customer.isSelected);
    this.activeModal.close({ success: true, customer: cust[0] });
  }
  OnClose() {
    this.activeModal.dismiss('Cross click');
    this.isSelectActive = false;
  }
}
